export default {
  currentMenu({ commit, state }, path) {
    for (let k = 0; k < state.menuList.length; k += 1) {
      if (state.menuList[k].url === path) {
        commit('SET_CURRENT_MENU', state.menuList[k]);
        break;
      }
      if (state.menuList[k].children) {
        for (let j = 0; j < state.menuList[k].children.length; j += 1) {
          if (state.menuList[k].children[j].url === path) {
            commit('SET_CURRENT_MENU', state.menuList[k].children[j]);
            commit('SET_CURRENT_OPEN_MENU', state.menuList[k].url);
            break;
          }
        }
      }
    }
  },
  toggleSideNav(ctx, playload) {
    ctx.commit('TOGGLE_SIDE_NAV', playload);
  },
  currentProjectId(ctx, id) {
    ctx.commit('CURRENT_PROJECT_ID', id);
    localStorage.setItem('CURRENT_PROJECT_ID', id);
  },
  userInfo(ctx, id) {
    ctx.commit('USER_INFO', id);
  },
  authUrlList(ctx, playload) {
    ctx.commit('AUTH_URL_LIST', playload);
  },
  lang(ctx, playload) {
    ctx.commit('LANG', playload);
  },
  dictionary(ctx, playload) {
    ctx.commit('DICTIONARY', playload);
  },
  dataCartListPush(ctx, playload) {
    ctx.commit('DATA_CART_LIST_PUSH', playload);
  },
  dataCartListReplace(ctx, playload) {
    ctx.commit('DATA_CART_LIST_REPLACE', playload);
  },
  dataCartListDelOne(ctx, playload) {
    ctx.commit('DATA_CART_LIST_DEL_ONE', playload);
  },
  xArea(ctx, playload) {
    ctx.commit('X_AREA', playload);
  },
  cloudValue(ctx, playload) {
    ctx.commit('CLOUD_VALUE', playload);
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js